import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'select-type-field',
  templateUrl: './select-type-field.component.html',
  styleUrl: './select-type-field.component.scss'
})
export class SelectTypeFieldComponent extends FieldType {
  onKeydown(event: KeyboardEvent) {
    const key = event.key?.toLowerCase();
    if (key === 'delete' || key === 'backspace') {
      this.formControl.setValue(null);   
      this.formControl.markAsDirty();
      this.formControl.markAsTouched();
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
